import { Box, styled } from '@mui/material';

export const ActionButtonsContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
}));
